/**
 * WHICH BOOK OPERATIONS ON THE PUBLIC /api/v1/app ENDPOINT CARRY THE CALLER'S
 * ID TOKEN (sign-out increment, 2026-10-07).
 *
 * `app-check-only`: App Check, never `Authorization: Bearer`. Backend confirmed
 * against rc.3 (dc345b48): these reads use no caller identity for their result
 * (slots meter by IP only, with no actor dimension and no own-hold filtering;
 * any change would come as a versioned contract change with notice). Sending
 * the token anyway exposed them to the session floor: a persisted, revoked
 * session made the booking page itself fail ("We couldn't load the booking
 * page") instead of reaching sign-in, and it put an identity on reads that
 * need none.
 *
 * The appointment link's operations are `app-check-only` too (Backend,
 * dc345b48): they use no uid for results, authorisation or audit; the link's
 * token is the sole authority. The session-floor check runs for ANY request
 * carrying a Bearer, so sending one let a revoked session break a valid
 * emailed link, the one way a person whose session ended can still open and
 * cancel their appointment. (RescheduleByAccessToken, not yet used by Book,
 * is the same.)
 *
 * `identity`: the caller's ID token when one exists, as before. Holds and
 * booking writes are owned by the token's uid.
 *
 * Every operation Book sends to /app is listed; tests/… appOperations.test.ts
 * fails on one that is not, so a new operation cannot silently join either
 * side. An operation missing from this map keeps today's behaviour
 * (`identity`).
 *
 * Not yet adopted, for the record: `submitSignedOutHelpRequest` REFUSES a
 * signed-in, non-anonymous caller with FORBIDDEN (Backend, 2026-10-07); when
 * Book adopts it, it is `app-check-only`.
 */
export const APP_OPERATION_IDENTITY = Object.freeze({
  ResolveBookingSlug: "app-check-only",
  GetProfessionalProfile: "app-check-only",
  GetAvailableSlots: "app-check-only",
  CurrentTerms: "app-check-only",

  CreateSlotHold: "identity",
  ReleaseSlotHold: "identity",
  CreateBooking: "identity",
  RequestGuestEmailCode: "identity",
  VerifyGuestEmailCode: "identity",
  CreateGuestBooking: "identity",

  ResolveAppointmentAccess: "app-check-only",
  PreviewAppointmentAccessCancellation: "app-check-only",
  CancelAppointmentByAccessToken: "app-check-only",
} as const satisfies Record<string, "app-check-only" | "identity">);

/** The /app operations that never carry the caller's ID token. */
export const APP_CHECK_ONLY_OPERATIONS: ReadonlySet<string> = new Set(
  Object.entries(APP_OPERATION_IDENTITY)
    .filter(([, mode]) => mode === "app-check-only")
    .map(([name]) => name)
);
